import Modifier from 'ember-modifier';

// @ts-ignore
import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';

export type TTheme = 'light' | 'dark' | 'auto';

interface IArgs {
  positional: [TTheme];
  named: {};
}

const Themes: TTheme[] = ['light', 'dark', 'auto'];

export default class ThemeModeModifier extends Modifier<IArgs> {
  constructor(owner: any, args: IArgs) {
    super(owner, args);
    registerDestructor(this, () => this.changeTheme('auto'));
  }

  modify(_element: Element, positional: [TTheme], _named: {}): void {
    this.scheduleThemeUpdate(positional[0]);
  }

  @action
  changeTheme(theme: TTheme) {
    document.querySelector(':root')?.setAttribute('data-theme-mode', theme);
  }

  @action
  scheduleThemeUpdate(theme: TTheme) {
    if (Themes.includes(theme)) {
      scheduleOnce('afterRender', this, () => this.changeTheme(theme));
    }
  }
}
